import React, { Component } from 'react'
import { Cascader } from 'antd'
import { injectIntl } from 'react-intl'
import { withApollo } from '@apollo/client/react/hoc'

import TZ from '../../resources/timezones'
import { isMatch } from '../../components/utils/searchUtils'
import { last } from 'lodash'

const TZ_FOR_DRAX_BEFORE_V5 = [
	'Africa/Cairo',
	'America/Anchorage',
	'America/Caracas',
	'America/Chicago',
	'America/Denver',
	'America/Los_Angeles',
	'America/New_York',
	'America/Sao_Paulo',
	'Australia/Adelaide',
	'Australia/Brisbane',
	'Australia/Darwin',
	'Australia/Sydney',
	'Europe/London',
	'Europe/Moscow',
	'Europe/Paris',
	'Asia/Bangkok',
	'Asia/Dhaka',
	'Asia/Dubai',
	'Asia/Hong_Kong',
	'Asia/Karachi',
	'Asia/Tokyo',
	'Pacific/Honolulu',
	'Pacific/Noumea'
]

class ISelectTimezone extends Component {
	getTimezones = () => {
		const draxBeforeV5 = this.props.draxBeforeV5 ?? false
		const timezones = TZ.map((region) => ({
			value: region.group,
			label: region.group,
			children: region.zones.map((zone) => ({
				value: zone.value,
				label: zone.name
			}))
		}))

		if (draxBeforeV5) {
			// Drax before version 5 only handles a subset of timezones
			const timeZonesForDraxBeforeV5 = []
			for (const region of timezones) {
				const regionForDraxBeforeV5 = {
					value: region.value,
					label: region.label,
					children: [
						...region.children.filter((zone) =>
							TZ_FOR_DRAX_BEFORE_V5.includes(zone.value)
						)
					]
				}

				if (regionForDraxBeforeV5.children.length > 0) {
					timeZonesForDraxBeforeV5.push(regionForDraxBeforeV5)
				}
			}

			return timeZonesForDraxBeforeV5
		}

		return timezones
	}

	filter(inputValue, path) {
		// path contains the region and the timezoneItem
		// example :
		// [
		// 	{
		// 		"value": "Americas",
		// 		"label": "Americas",
		// 		"children": [...]
		// 	},
		// 	{
		// 		"value": "America/Chihuahua",
		// 		"label": "Chihuahua"
		// 	}
		// ]
		// since the zone contains the region in its value, we check only the item value/label for match
		return (
			isMatch(path[1]?.value, inputValue, true) ||
			isMatch(path[1]?.label, inputValue, true)
		)
	}

	render() {
		const TZs = this.getTimezones()

		// The cascader expects an array of values for the selected value
		// this array represents the path to the selected value in the options tree
		// we search in the TZ list the corresponding timezone to rebuild the path.
		// If we don't find it we just use the selected value as the path to be displayed in the input
		let selectedPath = this.props.selectedValue
		if (this.props.selectedValue) {
			for (const region of TZs) {
				for (const zone of region.children) {
					if (zone.value === this.props.selectedValue) {
						selectedPath = [region.value, zone.value]
						break
					}
				}
			}
		}

		return (
			<Cascader
				style={{ width: '100%' }}
				placeholder={this.props.intl.formatMessage({
					id: 'deviceTimezone'
				})}
				options={TZs}
				value={selectedPath}
				// we return the last value which is the timezone
				onChange={(values) => this.props.onSelect(last(values))}
				showSearch={{ filter: this.filter }}
				allowClear={false}
			/>
		)
	}
}

export const SelectTimezone = withApollo(injectIntl(ISelectTimezone))
